export const ROUTES = {
    auth: {
        confirm: '/auth/confirm-code/',
        register_tg: '/auth/register/',
        login_tg: '/auth/login/',
        refresh: '/auth/refresh/',
    },
    regions: {
        all: '/regions/',
    },
}
